import { HttpClient, HttpEvent, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
// import {environment} from "../../../environments/environment";
import { environment } from "../../environments/environment";
import { ApiServiceService } from "../Services/api-service.service";

/**
 * @author Okala III
 */
@Injectable({
  providedIn: "root",
})
export class UploadFileService {
  SERVER_URL = environment.loginUrl;

  constructor(
    private http: HttpClient,
    private service: ApiServiceService,
  ) {}

  // Cloudupload(file: File): Observable<HttpEvent<any>> {
  //   const formData: FormData = new FormData();
  //   formData.append('multipartFile', file);
  //   const req = new HttpRequest('POST', `${this.SERVER_URL}/auth/utility/cloud/upload`, formData);
  //   return this.http.request(req);
  // }

  Cloudupload(formData: any): Observable<HttpEvent<any>> {
    const req = new HttpRequest(
      "POST",
      `${this.SERVER_URL}/auth/utility/cloud/upload`,
      formData,
      {
        reportProgress: true,
      },
    );
    return this.http.request(req);
  }
  Cloudupload2(formData: any): Observable<HttpEvent<any>> {
    const req = new HttpRequest(
      "POST",
      `${this.SERVER_URL}/auth/utility/cloud/upload/base64`,
      formData,
      {
        reportProgress: true,
      },
    );
    return this.http.request(req);
  }
}
